import { dispatchTrackingEvent } from '@context/tracking/utils';

export const trackWishlistChange = ({
  products,
  interaction,
}: {
  products: { product_code: string }[];
  interaction: 'remove_button' | 'move_button' | 'product_add';
}) => {
  dispatchTrackingEvent({
    event: 'wishlist_change',
    wishlist: {
      product_count: products.length,
      interaction,
      products,
    },
    _clear: true,
  });
};
